import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './i18n.resources';
import { myLocaleService } from './services/LocaleService/LocaleService.connected';

export const publicInstance = createInstance();

publicInstance.use(initReactI18next).init({
  ns: ['shortlists'],
  resources,
  lng: myLocaleService.useLocalStorageLanguage() || 'en',
  fallbackLng: 'en'
});

(publicInstance as any).IS_PUBLIC_INSTANCE = true;

myLocaleService.resolveAppLanguage().then(language => {
  void publicInstance.changeLanguage(language);
}).catch(() => {
  // If resolution fails, keep the initial language
});
